import { Component, OnInit } from "@angular/core";
import { MetaService } from "../meta.service";

@Component({
	selector: "features-cards",
	templateUrl: "./features-cards.component.html",
	styleUrls: ["./features-cards.component.css"],
})
export class FeaturesCardsComponent implements OnInit {
	//declare variables
	isCollapsed: boolean = false;

	//inject services
	constructor(private mds: MetaService) {}

	public toggleCollapse() {
		if (this.isCollapsed) {
			document.getElementById("see-less").style.display = "none";
			document.getElementById("full-list").style.display = "block";

			document
				.getElementsByClassName("cards-collapse")[0]
				.classList.toggle("active");
		} else {
			document.getElementById("see-less").style.display = "block";
			document.getElementById("full-list").style.display = "none";
			document
				.getElementsByClassName("cards-collapse")[0]
				.classList.toggle("active");
		}
		this.isCollapsed = !this.isCollapsed;
	}

	//initialize the component
	ngOnInit(): void {
		//SEO Optimization
		document.getElementById("see-less").style.display = "none";
	}
}
